import { IconFunctionalCalendar16, IconFunctionalErrorCircle16 } from '@cian/ui-kit-design-tokens/icons';
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

import { trackSetFrequencyClick, trackTuneFrequencyClick } from './tracking';
import { toggleChatbotPeriodicityMenu } from '../../actions/chatbot/actions';
import { addTextMessageToChat, setDeleteMessage } from '../../actions/sendMessage';
import { ChatbotButton, ChatbotButtonPeriodicity } from '../../components/ChatbotButton';
import { CHATBOT_ID } from '../../constants/chatbotId';
import { chatbotSelector } from '../../selectors';
import { applyPeriodicitySettings } from '../../thunks/chatbot';
import { TChatbotPeriodicity } from '../../types/chatbot';
import { TThunkDispatch } from '../../types/redux/thunk';
import { useApplicationContext } from '../../utils/applicationContext';

export const TunePeriodicityButtonContainer: React.FC = () => {
  const [outcomingMessageId] = useState([uuid(), uuid()]);
  const dispatch = useDispatch<TThunkDispatch>();
  const { custom } = useApplicationContext();
  const { periodicity, isPeriodicityMenuOpened } = useSelector(chatbotSelector);
  const buttons = [
    {
      name: 'daily' as const,
      title: 'Раз в день',
    },
    {
      name: 'everyThreeDays' as const,
      title: 'Раз в три дня',
    },
    {
      name: 'weekly' as const,
      title: 'Раз в неделю',
    },
  ];

  const handleTunePeriodicityClick = useCallback(() => {
    if (!isPeriodicityMenuOpened) {
      trackTuneFrequencyClick();
      dispatch(addTextMessageToChat('Настроить регулярность', CHATBOT_ID, outcomingMessageId[0]));
      dispatch(
        addTextMessageToChat('Как часто вы хотели бы получать такие подборки?', CHATBOT_ID, outcomingMessageId[1], 0),
      );
    }

    dispatch(toggleChatbotPeriodicityMenu());
  }, [dispatch, isPeriodicityMenuOpened, outcomingMessageId]);

  const handlePeriodicityChange = useCallback(
    (value?: TChatbotPeriodicity) => {
      if (value) {
        trackSetFrequencyClick(value);
        dispatch(applyPeriodicitySettings(value)).finally();
      } else {
        trackSetFrequencyClick();
      }

      dispatch(
        setDeleteMessage({
          chatId: CHATBOT_ID,
          messageId: outcomingMessageId[0],
          messagesMap: custom.messagesMap,
        }),
      );
      dispatch(
        setDeleteMessage({
          chatId: CHATBOT_ID,
          messageId: outcomingMessageId[1],
          messagesMap: custom.messagesMap,
        }),
      );

      dispatch(toggleChatbotPeriodicityMenu(false));
    },
    [custom.messagesMap, dispatch, outcomingMessageId],
  );

  return (
    <>
      {!isPeriodicityMenuOpened && (
        <ChatbotButton
          theme="fill_white_primary"
          beforeIcon={<IconFunctionalCalendar16 color="icon-main-default" />}
          onClick={handleTunePeriodicityClick}
        >
          Настроить регулярность
        </ChatbotButton>
      )}

      {isPeriodicityMenuOpened && (
        <>
          {buttons.map(({ name, title }) => (
            <ChatbotButtonPeriodicity
              key={name}
              isActive={periodicity === name}
              onClick={() => handlePeriodicityChange(name)}
            >
              {title}
            </ChatbotButtonPeriodicity>
          ))}

          <ChatbotButton
            theme="fill_white_primary"
            beforeIcon={<IconFunctionalErrorCircle16 color="icon-main-default" />}
            onClick={() => handlePeriodicityChange()}
          >
            Оставить как есть
          </ChatbotButton>
        </>
      )}
    </>
  );
};
